import AnimateHeight from 'react-animate-height';
import { t } from 'ttag';
import Btn from 'components/Btn/index.js';
import OpeningHours from 'components/OpeningHours/index.js';
import IconStar from 'static/icons/star.svg';
import IconMail from 'static/icons/mail.svg';
import IconPhone from 'static/icons/phone.svg';
import IconCheck from 'static/icons/check.svg';
import IconXmark from 'static/icons/xmark.svg';
import IconBuilding from 'static/icons/building.svg';
import IconLocationDot from 'static/icons/location-dot.svg';
import { SiteListContext } from '..';
import './index.scss';

const SiteListItem = ({ site, isExpanded, onClick, onMouseEnter, onMouseLeave, headerChildren, children }) => {
    const { isNearest, name, company, location, email, phone, has_pickup, id } = site;
    const { address = '', city = '', lat, lng } = location || {};

    const hasPin = lat && lng;

    return (
        <li
            className={`site-list-item ${isNearest ? 'nearest' : ''} ${isExpanded ? 'expanded' : ''}`}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <Btn onClick={() => onClick(id)} variant='PLAIN' className='list-item-toggle'>
                <h3>{name}</h3>
                {headerChildren && (
                    <SiteListContext.Provider value={site}>
                        {headerChildren}
                    </SiteListContext.Provider>
                )}
                {isNearest && <IconStar />}
                {!hasPin && (
                    <div className='no-pin-icon-wrap' title={t`(ELV_STATION_LIST_MAP)_SITE_HAS_NO_LOCATION_TOOLTIP`}>
                        <IconLocationDot />
                        <IconXmark />
                    </div>
                )}
            </Btn>
            <AnimateHeight animateOpacity duration={200} height={isExpanded ? 'auto' : 0}>
                <div className='list-item-body'>
                    <span className='site-info site-info-name'>
                        <IconBuilding />
                        {company?.name || '-'}
                    </span>
                    <span className='site-info'>
                        <IconLocationDot />
                        {[address, city].filter(v => v).join(', ') || '-'}
                    </span>
                    {email && (
                        <a href={`mailto:${email}`} className='site-info'>
                            <IconMail />
                            {email}
                        </a>
                    )}
                    {phone && (
                        <a href={`tel:${phone}`} className='site-info'>
                            <IconPhone />
                            {phone}
                        </a>
                    )}
                    <OpeningHours shop={site} />
                    <span className='site-info site-info-pickup'>
                        {has_pickup ? (
                            <>
                                <IconCheck />
                                {t`(ELV_STATION_LIST_MAP)_SITE_PICKUP_AVAILABLE`}
                            </>
                        ) : (
                            <>
                                <IconXmark />
                                {t`(ELV_STATION_LIST_MAP)_SITE_PICKUP_UNAVAILABLE`}
                            </>
                        )}
                    </span>
                    {children && (
                        <SiteListContext.Provider value={site}>
                            {children}
                        </SiteListContext.Provider>
                    )}
                </div>
            </AnimateHeight>
        </li>
    );
};

export default SiteListItem;
